import { useState } from "react";
import Tabs from "@/components/Usados/Tabs";
import ListarMovimientos from "./movimientosTab/listar";
import CrearMovimiento from "./movimientosTab/crear";
import GraficoMovimiento from "./movimientosTab/grafico";
import PresupuestoProyecto from "./movimientosTab/balance";

export default function MovimientosTab() {
  const [activeTab, setActiveTab] = useState("Listar");
  const [movimientoParaEditar, setMovimientoParaEditar] = useState<any>(null);

  const handleEditar = (movimiento: any) => {
    setMovimientoParaEditar(movimiento);
    setActiveTab("crear");
  };

  const handleFinalizado = () => {
    setMovimientoParaEditar(null);
    setActiveTab("Listar");
  };

  const tabs = [
    {
      value: "Listar",
      label: "Lista de movimientos",
      content: <ListarMovimientos onEdit={handleEditar} />,
    },
    {
      value: "crear",
      label: movimientoParaEditar ? "Editar movimiento" : "Crear movimiento",
      content: (
        <CrearMovimiento
          movimiento={movimientoParaEditar}
          onSuccess={handleFinalizado}
          onCancel={() => {
            setMovimientoParaEditar(null);
            setActiveTab("Listar");
          }}
        />
      ),
    },
    {
      value: "Grafico",
      label: "Grafico de movimientos",
      content: <GraficoMovimiento />,
    },
    {
      value: "Balance",
      label: "Balance de movimientos",
      content: <PresupuestoProyecto />,
    },
  ];

  return (
    <div className="space-y-6">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeTextClass="text-green-800"
        activeBorderClass="border-green-800"
        activeGlowClass="bg-green-800/40"
      />
    </div>
  );
}
